<template>
    <div class="stakee-ad-mobile-wrapper">
        <div class="stakee-ad-mobile" v-on:click="openAdLink">
            <div class="stakee-ad-mobile__header">
                {{ $t(`ads.stakee.mobile.title`) }}
                <ui-link v-bind:to="{ name: 'advertise' }" class="stakee-ad-mobile__sponsored-tag" v-on:click.native.stop>
                    {{ $t('ads.sponsored') }}
                </ui-link>
            </div>
            <div class="stakee-ad-mobile__description" v-html="$t(`ads.stakee.mobile.description`)" />
            <img v-bind:src="bannerUrl" class="stakee-ad-mobile__banner" alt="Stakee" />
            <img v-bind:src="maskGridUrl" class="stakee-ad-mobile__mask-grid" alt="" />
        </div>
    </div>
</template>

<script>
import maskGridUrl from '@img/advertise/mask-grid.png';
import bannerUrl from '@img/advertise/stakee/safe.png';

export default {
    data() {
        return {
            maskGridUrl,
            bannerUrl,
        };
    },
    methods: {
        openAdLink() {
            window.open(this.$t('ads.stakee.link'), '_blank');
        },
    },
};
</script>

<style lang="scss">
.stakee-ad-mobile {
    &-wrapper {
        padding: 0 16px;
        box-sizing: border-box;
        width: 100%;
        margin-top: 16px;
    }

    display: block;
    background: linear-gradient(to right, #1E8DFF, #125599);
    font-family: Nunito, Rubik, Roboto, Ubuntu, Arial, sans-serif;
    color: white;
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 65px;
    border-radius: 12px;
    box-shadow: 0 0.5rem 1.2rem var(--card-box-shadow-color);
    font-size: 14px;
    overflow: hidden;
    padding: 10px 16px;
    cursor: pointer;

    &__header {
        display: flex;
        align-items: center;
        gap: 7px;
        font-family: var(--font-heading);
        font-size: 16px;
        font-weight: 800;
        margin-bottom: 4px;
    }

    &__description {
        max-width: 340px;
        z-index: 100;
        font-family: Rubik, Roboto, Ubuntu, Arial, sans-serif;

        b {
            font-weight: 500;
        }
    }

    &__sponsored-tag {
        font-size: 10px;
        padding: 1px 7px;
        border-radius: 10px;
        font-weight: 800;
        text-transform: uppercase;
        background-color: rgba(255, 255, 255, 0.19);
        color: white;
        z-index: 99;

        &:hover {
            text-decoration: none;
        }
    }

    &__banner {
        position: absolute;
        width: 48px;
        top: 7px;
        right: 12px;
        z-index: 9;
    }

    &__mask-grid {
        position: absolute;
        width: auto;
        height: 200px;
        top: 0;
        right: 0;
        z-index: 8;
    }
}
</style>
